export class PENDINGPOINT {
    Type: string = "PENDINGPOINT";

    registerId?: string;
    registerPointId?: string;
    auditPointId?: string;
    machineId?: string;
    workOrder?: string;
}